(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("reportResource", ["$resource", reportResource]);
    function reportResource($resource) {
        return $resource("/api/reports/:action/:actionValue/:param1", {}, {
            getExamDetails: {
                method: "GET",
                params: { action: "test-item-details" }
            },
            getAnswers: {
                method: "GET",
                params: { action: "test-item-details" },
                cache: true
            }
        });
    }
}());
